module.exports = __webpack_public_path__ + "odinstatic/media/sidebar-shield-active.c2b48cd4.svg";